import { useMemo } from 'react'

import { TooltipContentType } from '../../__generated__/graphql/catalog/graphql'
import { useFixturesContext } from '../../brunswick/containers/fixtures/FixturesContext'

/**
 * Get the tooltip fixture object for a given label & content type.
 *
 * @param enumValue - The target "enumValue" to use when searching for the tooltip fixture.
 * @param contentType - A value from the `TooltipContentTypes` enum that specifies which tooltip content types to look for.
 *
 * @returns The tooltip fixture object, or `undefined` if no tooltip was found.
 */
export function useTooltipFixture(enumValue: string, contentType: TooltipContentType) {
  const { tooltips } = useFixturesContext()

  const tooltip = useMemo(() => {
    return tooltips?.find(t => t.contentType === contentType && t.enumValue.name === enumValue)
  }, [tooltips, enumValue, contentType])

  return tooltip
}
